import type { ReactNode } from 'react';

import Text from '@cartwhl/ui/base/TextNew';

export interface ProfileSectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  boxed?: boolean;
  className?: string;
  contentClassName?: string;
}

export default function ProfileSection({
  title,
  subtitle,
  actions,
  children,
  boxed = true,
  className,
  contentClassName,
}: ProfileSectionProps) {
  return (
    <section className={`flex flex-col gap-5 ${className ?? ''}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <Text as="h2" token="14/medium">
            {title}
          </Text>
          {subtitle ? (
            <Text as="p" token="14" className="text-tertiary mt-1">
              {subtitle}
            </Text>
          ) : null}
        </div>
        {actions}
      </div>

      {boxed ? (
        <div
          className={`border-gray-30 dark:border-gray-60 dark:bg-gray-90/30 rounded-xl border bg-white p-6 shadow-sm ${
            contentClassName ?? ''
          }`}
        >
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  );
}
